// extracted by mini-css-extract-plugin
module.exports = {"CTACard":"CTACard_CTACard__irwtT"};